/**
 * Privacy configuration strategy for rrweb session recording
 */

export interface PrivacyConfig {
  maskAllInputs: boolean;
  sensitiveSelectors: string[];
  enablePrivacyMode: boolean;
}

export class RRWebPrivacyConfig {
  private config: PrivacyConfig;

  constructor(config: PrivacyConfig) {
    this.config = config;
  }

  /**
   * Generate rrweb privacy configuration
   */
  getRRWebConfig() {
    return {
      maskAllInputs: this.config.maskAllInputs,
      blockSelector: this.config.sensitiveSelectors.join(','),
      maskTextSelector: this.config.enablePrivacyMode 
        ? this.config.sensitiveSelectors.join(',') 
        : '',
      ignoreSelector: '[data-sensitive], .sensitive, .password, .ssn, .credit-card',
      maskInputOptions: {
        password: true,
        email: this.config.enablePrivacyMode,
        tel: this.config.enablePrivacyMode,
        text: this.config.maskAllInputs,
        textarea: this.config.maskAllInputs,
        select: false,
        radio: false,
        checkbox: false
      },
      sampling: {
        scroll: 150,
        input: 'last' as const,
        mousemove: 50,
        media: 800
      },
      slimDOMOptions: {
        comment: true,
        script: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
      }
    };
  }

  /**
   * Update privacy configuration
   */
  updateConfig(updates: Partial<PrivacyConfig>): void {
    this.config = { ...this.config, ...updates };
  }
}

